import React from 'react'
import { FlatList, StyleSheet } from 'react-native'

import { colors, H6, SH3, Stack, XStack } from '@zet/design-system'
import { CategoryHeader, HowItWorksProps } from '@zet/zet-prime'

export default function HowItWorks({ title, steps }: HowItWorksProps) {
  const renderTextWithBold = (text: string) => {
    const regex = /(₹\d+\/\w+)/g
    const parts = text.split(regex)

    return parts.map((part, idx) => {
      if (regex.test(part)) {
        regex.lastIndex = 0
        return (
          <SH3 key={idx} style={{ fontFamily: 'Graphie-Bold' }}>
            {part}
          </SH3>
        )
      }
      return <SH3 key={idx}>{part}</SH3>
    })
  }

  const renderItem = ({ item, index }: { item: string; index: number }) => {
    return (
      <XStack className="items-center">
        <Stack style={styles.stepNumber}>
          <H6 className="text-white font-">{index + 1}</H6>
        </Stack>
        <SH3 className="w-[85%]">{renderTextWithBold(item)}</SH3>
      </XStack>
    )
  }

  return (
    <Stack className="px-4 py-2">
      <CategoryHeader title={title} />
      <FlatList
        data={steps}
        renderItem={renderItem}
        ItemSeparatorComponent={() => <Stack className="h-5" />}
        contentContainerStyle={styles.list}
      />
    </Stack>
  )
}

const styles = StyleSheet.create({
  list: {
    backgroundColor: colors.grays[10],
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderRadius: 16,
    borderWidth: 1,
    marginTop: 16,
    borderColor: '#EFECF2',
  },
  stepNumber: {
    borderRadius: 16,
    borderWidth: 2,
    borderColor: colors.primary[30],
    width: 32,
    height: 32,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
    backgroundColor: colors.primary[100],
  },
})
